<div class="pane-subheader theme-light d-flex" (click)="toggleOpen()" [ngClass]="{'open': open}">
  <div class="header-subtitle">
    <h2>{{ title }}</h2>
  </div>
  <div class="subtitle-actions pr-3">
    <div class="header-background round-background container-theme-light-icons icon-button">
      <i
        class="fa m-auto collapse-icon"
        [ngClass]="open ? 'fa-chevron-down' : 'fa-chevron-right'"
      ></i>
    </div>
  </div>
</div>
<div *ngIf="open" class="p-3">
  <ng-content></ng-content>
</div>
